// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const slaking: PokeData = {
  "id": 289,
  "name": "slaking",
  "height": 20,
  "weight": 1305,
  "base_experience": 252,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "mega-kick",
    "headbutt",
    "counter",
    "focus-energy",
    "amnesia",
    "fury-swipes",
    "rest",
    "slash",
    "flail",
    "reversal",
    "feint-attack",
    "endure",
    "swagger",
    "encore",
    "uproar",
    "focus-punch",
    "yawn",
    "slack-off",
    "covet",
    "hammer-arm",
    "fling",
    "punishment",
    "sucker-punch",
    "chip-away",
    "play-rough",
    "throat-chop"
  ],
  "moves": [
    "scratch",
    "headbutt",
    "play-rough",
    "quick-attack",
    "tri-attack",
    "scary-face",
    "refresh",
    "growl",
    "body-slam",
    "protect",
    "splash",
    "tackle",
    "leer"
  ],
  "evolution_chain": {
    "id": 143,
    "item": null,
    "species": [
      {
        "name": "slakoth",
        "order": 313,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "vigoroth",
        "order": 314,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 287,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "slaking",
        "order": 315,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 288,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 124,
    "speed": 106,
    "ability_power": 170
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
